<template>
  <v-form :ref="setFormRef" @submit.prevent="$emit('submit')">
    <AppRow>
      <SearchBox
        v-model="search"
        :rules="[required]"
        :placeholder="$tt('blog.find_articles')"
        hide-details
        clearable
        @click:clear="clear"
      />
      <AppBtn type="submit" :disabled="!valid" block>
        {{ $tt('blog.search') }}
      </AppBtn>
    </AppRow>
  </v-form>
</template>

<script setup lang="ts">
const search = defineModel<string>({ required: true });

const { required } = useValidation();
const { valid, setFormRef } = useForm();

const emit = defineEmits(['submit']);

function clear() {
  search.value = '';
  emit('submit');
}
</script>

<style scoped>
@media (min-width: 851px) {
  .v-btn {
    padding-inline: var(--space-6);
    max-width: fit-content;
  } 
}
</style>